import React from "react";
import { findAllSemesterPagedEvent } from "../../_events/semester/find.event";
import { alertError } from "../../_utils/alerts";

export const useSemesterPaged = ({ page = 0, limit = 8 }) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l) => {
        findAllSemesterPagedEvent(p, l)
        .then(json => {
            setData(json.paged);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(page, limit);
    }, [page, limit]);

    return { data, loadData };
}